export const TRY_OPEN_COMMENT_BOX = 'effects/TRY_OPEN_COMMENT_BOX';
export const TRY_CLOSE_ALL_COMMENT_BOXES = 'effects/CLOSE_ALL_COMMENT_BOXES';
export const tryOpenCommentBox = (payload) => ({
    type: TRY_OPEN_COMMENT_BOX,
    payload,
});
export const tryCloseAllCommentBoxes = (payload) => ({
    type: TRY_CLOSE_ALL_COMMENT_BOXES,
    payload,
});
//# sourceMappingURL=comment-box-actions.js.map